export const MODAL_DATA_PARAM = 'md';
export const MODAL_PARAM = 'm';
